module.exports = __webpack_public_path__ + "static/media/s300.3ca57ba7.png";